import React,{useEffect, useRef, useState} from 'react';
import { FaUserCircle, FaBars, FaTimes, FaHome, FaNewspaper, FaPlus, FaUser, FaEnvelope } from "react-icons/fa";
import "./Header.css"
import { useNavigate, useLocation } from 'react-router-dom';
import CNLogo from "../../CNLogowhite.png"
import CLogo from "../../CLogo.png"
import CreatePostDropdown from '../../Utils/CreatePosts/createPost/createPost';
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from '../../Utils/AutoComplete';
import { updateLocation } from '../../redux/userSlice';
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../../Utils/corporateVerification.js";

function Header(props) {
  const navigate = useNavigate()
  const dispatch =useDispatch();
  const location = useLocation();
  const [search, setSearch] = useState("")
  const { userId, userDetails } = useSelector((state) => state.userReducer);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showCreateMenu, setShowCreateMenu] = useState(false);

  useEffect(()=>{
    if(userDetails.preferred_location){
    setInputValue(userDetails.preferred_location.split("_").length>1?userDetails.preferred_location.split("_")[1]:"")
    }
  },[userDetails.preferred_location])

  useEffect(()=>{
    if(userDetails.preferred_location){
    setInputValue(userDetails.preferred_location.split("_").length>1?userDetails.preferred_location.split("_")[1]:"")
    }
  },[userDetails.preferred_location, location])

  useEffect(()=>{
    dispatch(updateLocation(inputValue))
  },[inputValue, dispatch])

  const dropdownRef = useRef(null);
  
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowUserMenu(false);
    }
    // Close create menu when clicking outside
    if (!e.target.closest('.create-btn') && !e.target.closest('.mobile-create-menu')) {
      setShowCreateMenu(false);
    }
  };
  
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isAuthPage = ["/signup","/login","/","/about","/services","/contact","/faq","/forgotpassword"].includes(window.location.pathname.toLowerCase());
  
  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      navigate("/search?query="+e.target.value);
      setSearch("");
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Main Header */}
      <header className={`main-header ${isAuthPage ? 'header-auth' : 'header-main'}`}>
        {!isAuthPage ? (
          // Authenticated User Header
          <div className="header-wrapper">
            <div className="header-left">
              <div className="logo-container">
                <img 
                  className="logo-desktop" 
                  onClick={()=>{navigate(userId?"/home":"/")}} 
                  src={CNLogo} 
                  alt="Corporate NRI" 
                />
                <img 
                  className="logo-mobile" 
                  onClick={()=>{navigate(userId?"/home":"/")}} 
                  src={CLogo} 
                  alt="Corporate NRI" 
                />
              </div>
              
              <div className="location-selector">
                <Autocomplete inputValue={inputValue} setInputValue={setInputValue} />
              </div>
            </div>

            <div className="search-area">
              <div className="search-box">
                <input 
                  className="search-field" 
                  placeholder='Search for posts' 
                  value={search} 
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={handleSearch}
                />
              </div>
            </div>

            <div className="header-right">
              <div className="create-post-desktop">
                <CreatePostDropdown/>
              </div>
              <div className="user-menu-container" ref={dropdownRef}>
                <div 
                  className="user-profile-btn" 
                  onClick={() => setShowUserMenu(prev => !prev)}
                >
                  {userDetails.profile_pic && userDetails.profile_pic.length > 10 ? (
                    <img src={userDetails.profile_pic} alt="Profile" className="profile-avatar" />
                  ) : (
                    <FaUserCircle className="profile-icon" />
                  )}
                  <div className="user-details">
                    <span className="user-name">{userDetails.name}</span>
                    <span className="user-email">{userDetails.userEmail}</span>
                  </div>
                </div>

                {showUserMenu && (
                  <div className="user-dropdown-menu">
                    <div className="dropdown-option" onClick={() => { navigate("/profile"); setShowUserMenu(false); }}>
                      Profile
                    </div>
                    {window.innerWidth <= 768 && (
                      <div className="dropdown-option" onClick={() => { navigate("/messages"); setShowUserMenu(false); }}>
                        Messages
                      </div>
                    )}
                    <div className="dropdown-option logout-option" onClick={() => {
                      localStorage.clear();
                      navigate('/');
                      setShowUserMenu(false);
                    }}>
                      Logout
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          // Public Header
          <div className="header-wrapper">
            <div className="header-left">
              <div className="logo-container">
                <img 
                  className="logo-desktop" 
                  onClick={()=>{navigate("/")}} 
                  src={CNLogo} 
                  alt="Corporate NRI" 
                />
                <img 
                  className="logo-mobile" 
                  onClick={()=>{navigate("/")}} 
                  src={CLogo} 
                  alt="Corporate NRI" 
                />
              </div>
            </div>

            <nav className="main-navigation">
              <button className="nav-item" onClick={()=>{navigate("/about")}}>About</button>
              <button className="nav-item" onClick={()=>{navigate("/services")}}>Services</button>
              <button className="nav-item" onClick={()=>{navigate("/faq")}}>FAQ</button>
              <button className="nav-item" onClick={()=>{navigate("/contact")}}>Contact</button>
            </nav>

            <div className="header-right">
              <div className="auth-buttons">
                <button className="signin-btn" onClick={()=>{navigate("/login")}}>Sign In</button>
                <button className="signup-btn" onClick={()=>{navigate("/signUp")}}>Sign Up</button>
              </div>
              <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Mobile Bottom Navigation - Only for authenticated users */}
      {!isAuthPage && userId && (
        <nav className="mobile-bottom-nav">
          <button 
            className={`mobile-nav-btn ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
            onClick={() => navigate("/home")}
          >
            <FaHome className="nav-icon" />
            <span>Dashboard</span>
          </button>
          <button 
            className={`mobile-nav-btn ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
            onClick={() => navigate("/latest")}
          >
            <FaNewspaper className="nav-icon" />
            <span>Posts</span>
          </button>
          <button 
            className="mobile-nav-btn create-btn"
            onClick={() => setShowCreateMenu(prev => !prev)}
          >
            <div className="create-btn-circle">
              <FaPlus className="nav-icon plus-icon" />
            </div>
          </button>
          <button 
            className={`mobile-nav-btn ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
            onClick={() => navigate("/profile")}
          >
            <FaUser className="nav-icon" />
            <span>Profile</span>
          </button>
          <button 
            className={`mobile-nav-btn ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
            onClick={() => navigate("/messages")}
          >
            <FaEnvelope className="nav-icon" />
            <span>Messages</span>
          </button>
          
          {/* Create Post Dropdown Menu */}
          {showCreateMenu && (
            <div className="mobile-create-menu">
              <div className="create-menu-item" onClick={() => {
                if (!isCorporateVerified(userDetails)) {
                  navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
                } else {
                  navigate("/createRental");
                }
                setShowCreateMenu(false);
              }}>
                Create Rentals
              </div>
              <div className="create-menu-item" onClick={() => {
                if (!isCorporateVerified(userDetails)) {
                  navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
                } else {
                  navigate("/createCommerceListing");
                }
                setShowCreateMenu(false);
              }}>
                Create Commerce
              </div>
              <div className="create-menu-item" onClick={() => {
                if (!isCorporateVerified(userDetails)) {
                  navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
                } else {
                  navigate("/createOtherListing");
                }
                setShowCreateMenu(false);
              }}>
                Create Others
              </div>
            </div>
          )}
        </nav>
      )}

      {/* Mobile Menu Overlay */}
      {isAuthPage && isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}>
          <div className="mobile-menu-panel" onClick={(e) => e.stopPropagation()}>
            <nav className="mobile-navigation">
              <button className="mobile-nav-item" onClick={()=>{navigate("/about"); closeMobileMenu();}}>About</button>
              <button className="mobile-nav-item" onClick={()=>{navigate("/services"); closeMobileMenu();}}>Services</button>
              <button className="mobile-nav-item" onClick={()=>{navigate("/faq"); closeMobileMenu();}}>FAQ</button>
              <button className="mobile-nav-item" onClick={()=>{navigate("/contact"); closeMobileMenu();}}>Contact</button>
            </nav>
            <div className="mobile-auth-section">
              <button className="signin-btn mobile-btn" onClick={()=>{navigate("/login"); closeMobileMenu();}}>Sign In</button>
              <button className="signup-btn mobile-btn" onClick={()=>{navigate("/signUp"); closeMobileMenu();}}>Sign Up</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;